import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-body font-medium transition-all duration-300 focus-visible:outline-none disabled:opacity-60 disabled:pointer-events-none";
const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
};

const resolveTag = ({ to, href }) => {
  if (to) return { Tag: Link, extra: { to } };
  if (href) return { Tag: "a", extra: { href } };
  return { Tag: "button", extra: {} };
};

export const PrimaryButton = ({
  children,
  to,
  href,
  size = "md",
  className = "",
  withArrow = false,
  testId,
  ...rest
}) => {
  const { Tag, extra } = resolveTag({ to, href });
  return (
    <Tag
      data-testid={testId}
      className={`${base} ${sizes[size]} bg-orange text-white shadow-[0_10px_30px_-10px_rgba(255,90,0,0.6)] hover:scale-[1.04] hover:shadow-[0_0_28px_rgba(255,90,0,0.55)] ${className}`}
      {...extra}
      {...rest}
    >
      {children}
      {withArrow && <ArrowRight className="h-4 w-4" />}
    </Tag>
  );
};

export const SecondaryButton = ({
  children,
  to,
  href,
  size = "md",
  onDark = false,
  className = "",
  withArrow = false,
  testId,
  ...rest
}) => {
  const { Tag, extra } = resolveTag({ to, href });
  const tone = onDark
    ? "border-white/25 text-white hover:bg-white hover:text-navy"
    : "border-navy/20 text-navy hover:bg-navy hover:text-white";
  return (
    <Tag
      data-testid={testId}
      className={`${base} ${sizes[size]} border ${tone} ${className}`}
      {...extra}
      {...rest}
    >
      {children}
      {withArrow && <ArrowRight className="h-4 w-4" />}
    </Tag>
  );
};
